var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.5816 3.5816 0 8 0C12.4184 0 16 3.5816 16 8C16 12.4184 12.4184 16 8 16C3.5816 16 0 12.4184 0 8ZM8 8.8C7.78783 8.8 7.58434 8.71571 7.43431 8.56569C7.28429 8.41566 7.2 8.21217 7.2 8V4.8C7.2 4.58783 7.28429 4.38434 7.43431 4.23431C7.58434 4.08429 7.78783 4 8 4C8.21217 4 8.41566 4.08429 8.56569 4.23431C8.71571 4.38434 8.8 4.58783 8.8 4.8V8C8.8 8.21217 8.71571 8.41566 8.56569 8.56569C8.41566 8.71571 8.21217 8.8 8 8.8ZM6.8 11.2C6.8 10.8817 6.92643 10.5765 7.15147 10.3515C7.37652 10.1264 7.68174 10 8 10H8.008C8.32626 10 8.63148 10.1264 8.85653 10.3515C9.08157 10.5765 9.208 10.8817 9.208 11.2V11.208C9.208 11.5263 9.08157 11.8315 8.85653 12.0565C8.63148 12.2816 8.32626 12.408 8.008 12.408H8C7.68174 12.408 7.37652 12.2816 7.15147 12.0565C6.92643 11.8315 6.8 11.5263 6.8 11.208V11.2Z",
    fill: "#F44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationmark);
export default __webpack_public_path__ + "static/media/exclamationmark.ff942c103211086e645aa455368f3b78.svg";
export { ForwardRef as ReactComponent };